export class OrderService {
	id: string | undefined;
	packageId: string | undefined;
	issueDate: string | undefined;
	serviceId: string | undefined;
	priceGross: number | undefined;
	priceNet: number | undefined;
	commissionAmount: number | undefined;
	confirmationNumber: string | undefined;
}
